/**
 * This is a make-shift "Rounding Down" function -- it doesn't compute data, rather it manipulates the data as string
 * @param {number | string} data the input data could be integer, float number or string
 * @returns the data with up to two decimal places. For example: 50.2255 will result in 50.22
 */
export const roundDownNum = (data: number | string) => {
	if (isNaN(Number(data))) return 0;

	const str = typeof data === 'number' ? data.toString() : data;

	const regExpMatchArray = str.match(/^[-]?\d+\.?\d{0,2}/);

	return regExpMatchArray ? parseFloat(regExpMatchArray[0]) : 0;
};
